// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"LoginDialog_backdrop__0RlGY","root":"LoginDialog_root__Mjzeu"};